export enum PersonalDataTypes {
  PROFIL_PERSONAL_DATA = 'profilPersonalData',
  MANDATORY_UPDATE_PERSONAL_DATA = 'mandatoryUpdatePersonalData',
}
